import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

import ParameterLevelDropdownComponent from './Component';

class ParameterLevelDropdownContainer extends React.PureComponent {
  get options () {
    return map(this.props.levels, level =>
      ({ value: level, label: level, text: level })
    );
  }

  render () {
    const { levels, ...props } = this.props // eslint-disable-line
    return <ParameterLevelDropdownComponent options={this.options} {...props} />;
  }
}

ParameterLevelDropdownContainer.propTypes = {
  levels: PropTypes.array.isRequired,

  name: PropTypes.string
};

ParameterLevelDropdownContainer.defaultProps = {
  name: 'parameterLevel'
};

export default ParameterLevelDropdownContainer;
